import type { StackBarsEntities } from '../StackBars';

export const mapSumPositiveValues = (
  keys: string[],
  entities: StackBarsEntities
): number[] => {
  return keys
    .map((key) => {
      const columnValues = entities[key];
      if (!columnValues) {
        return null;
      }
      return columnValues
        .filter((val) => val && val >= 0)
        .reduce((acc: number, value) => acc + (value ?? 0), 0);
    })
    .filter((n): n is number => n !== null);
};

export const mapSumNegativeValues = (
  keys: string[],
  entities: StackBarsEntities
): number[] => {
  return keys
    .map((key) => {
      const columnValues = entities[key];
      if (!columnValues) {
        return null;
      }
      return columnValues
        .filter((val) => val && val < 0)
        .reduce((acc: number, value) => acc + (value ?? 0), 0);
    })
    .filter((n): n is number => n !== null);
};
